import React from 'react'
import { useCallback, useEffect } from "react";
import { useDispatch, useSelector} from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import TabbedHeader from '../../../../../Utils/layout/components/header/TabbedHeader/TabbedHeader';
import { Tracker } from "../../../../util/analytics";
import * as helpers from "../../../../util/helpers";
import { useMobileViewport } from "../../../../util/mobileViewPort";
import { setConfigurationPageTabIndex } from "../../state/slices/configurationSlice";

const configurationTabLabelsMap = {
  phonebooks: "Phonebooks",
  dispositions: "Dispositions",
  sounds: "Sounds",
  reports: "Reports",
  templates: "Templates",
  "sticky-agent": "Sticky Agents",
};

const ConfigurationSubHeader = (props) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();

  const selectedTab = useSelector(
    (state) => state.configurationSlice.activeTab,
  );

  const isFeatureEnabled = (feature) => {
    return helpers.isFeatureEnabled(feature);
  };
  let assumeId = localStorage.getItem("assume_id");
  assumeId = (assumeId === 'null' || assumeId === '' || assumeId === 'None') ? false : assumeId;
  const configurationTabPaths = [
    ...((!helpers.isAgent() &&
      isFeatureEnabled("is_phonebook_tab_enabled") && (!helpers.isFeatureEnabledProfile('restrict_campaign_tab') || assumeId) &&
      !helpers.isFeatureEnabledProfile('is_suspended_account') && ["phonebooks"]) ||
      []),
    ...((!helpers.isAgent() &&
      helpers.is_disposition_enabled() &&
      isFeatureEnabled("is_disposition_tab_enabled") &&
      helpers.isFeatureEnabledProfile('is_disposition_enabled') && ["dispositions"]) ||
      []),
    ...((!helpers.isAgent() &&
      isFeatureEnabled("is_sound_tab_enabled") && ["sounds"]) ||
      []),
      ...((!helpers.isAgent() &&
      isFeatureEnabled("is_reports_enabled") && ["reports"]) ||
      []),
    ...((!helpers.isAgent() &&
      isFeatureEnabled("is_template_enabled") && ["templates"]) ||
      []),
    ...(((helpers.isCallCenterEnabled() && !helpers.isAgent()) &&
      isFeatureEnabled("is_stickynote_tab_enabled") && ["sticky-agent"]) ||
      []),
  ];

  const splitLocationPathname = useCallback(() => {
    return location.pathname.split("/")[1];
  }, [location.pathname]);

  useEffect(() => {
    if (location.pathname) {
      Object.keys(configurationTabPaths).forEach((path, index) => {
        if (configurationTabLabelsMap[splitLocationPathname()]) {
          if (splitLocationPathname() === configurationTabPaths[index]) {
            handleOnTabChange(null, index);
          } else {
            if (!configurationTabPaths.includes(splitLocationPathname())) {
              history.push(`/`);
            }
          }
        }
      });
    }
  }, [splitLocationPathname]);

  const handleOnTabChange = (event, newValue) => {
    dispatch(setConfigurationPageTabIndex(newValue));
    history.push(`/${configurationTabPaths[newValue]}`);
    if (event) {
      Tracker.event(
        configurationTabLabelsMap[configurationTabPaths[newValue]],
        `Click`,
        `${
          configurationTabLabelsMap[configurationTabPaths[newValue]]
        } Tab Click`,
        `${
          configurationTabLabelsMap[configurationTabPaths[newValue]]
        } Tab Click Top`,
        helpers.getUser()
      );
    }
  };

  return (
    <div className="d-flex flex-grow-1">
      {!useMobileViewport() && (
        <TabbedHeader
          value={selectedTab}
          ariaLabel="configuration"
          handleChange={handleOnTabChange}
          tabList={[
            ...((!helpers.isAgent() &&
              isFeatureEnabled("is_phonebook_tab_enabled") && (!helpers.isFeatureEnabledProfile('restrict_campaign_tab') || assumeId) &&
              !helpers.isFeatureEnabledProfile('is_suspended_account') && ["Phonebooks"]) ||
              []),
            ...((!helpers.isAgent() &&
              helpers.is_disposition_enabled() &&
              helpers.isFeatureEnabledProfile('is_disposition_enabled') &&
              isFeatureEnabled("is_disposition_tab_enabled") && ["Dispositions"]) || 
              []),
            ...((!helpers.isAgent() &&
              isFeatureEnabled("is_sound_tab_enabled") && ["sounds"]) ||
              []),
            ...((!helpers.isAgent() &&
              isFeatureEnabled("is_reports_enabled") && ["Reports"]) ||
              []),
            ...((!helpers.isAgent() &&
              isFeatureEnabled("is_template_enabled") && ["templates"]) ||
              []),
            ...(((helpers.isCallCenterEnabled() && !helpers.isAgent()) &&
              isFeatureEnabled("is_stickynote_tab_enabled") && [
                "Sticky Agents",
              ]) ||
              []),
          ]}
        />
      )}
    </div>
  );
};

export default ConfigurationSubHeader;
